import "./index.css";

const USE_REMOTE_SHELL = process.env.REACT_APP_USE_REMOTE_SHELL === "true";

if (USE_REMOTE_SHELL) {
  // Reverse mode: load mf-root-app shell bundle, site-monitoring mounts inside it
  import("./reverse-shell/index");
} else {
  // Standalone mode: run site-monitoring with its own router and auth
  import("./standalone");
}

// In reverse-shell mode, HMR updates are handled by a custom
// module.hot.accept("../App") handler in mountPlatform.tsx.
// For changes outside the App tree, webpack/hot/dev-server.js
// automatically falls back to window.location.reload().
